module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.submitting) ? _c('spinner') : _vm._e(), _vm._v(" "), (!_vm.loadFailed && !_vm.success && !_vm.submitting) ? [_c('b-form-group', {
    attrs: {
      "state": _vm.errors.first('password') || (_vm.password && !_vm.isValidPassword) ? false : true,
      "invalid-feedback": _vm.errors.first('password') || _vm.passwordErrorMessage,
      "label": "Ingresa tu nueva contraseña",
      "label-for": "password",
      "description": "Recomendaciones: Agrega números y mayúsculas. Usa palabras poco comunes. Evita repetir palabras o caractereres. Agrega una o dos palabras."
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "password",
    attrs: {
      "state": _vm.errors.first('password') || (_vm.password && !_vm.isValidPassword) ? false : null,
      "name": "password",
      "id": "password",
      "type": "password"
    },
    on: {
      "keyup": function($event) {
        _vm.errorMessage = ''
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('b-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "mb-4",
    attrs: {
      "value": _vm.passwordScore,
      "max": 4,
      "animated": "",
      "variant": _vm.isValidPassword ? 'success' : 'danger'
    }
  }), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": _vm.errors.first('confirmPassword') ? false : true,
      "invalid-feedback": _vm.errors.first('confirmPassword'),
      "label": "Confirma tu contraseña",
      "label-for": "confirmPassword"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    attrs: {
      "state": _vm.errors.first('confirmPassword') ? false : null,
      "name": "confirmPassword",
      "id": "confirmPassword",
      "type": "password"
    },
    on: {
      "keyup": function($event) {
        _vm.errorMessage = ''
      }
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage),
      expression: "errorMessage"
    }],
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row pr-3 d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "cursor-pointer",
    attrs: {
      "disabled": _vm.submitted,
      "variant": "primary"
    },
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitted),
      expression: "submitted"
    }],
    attrs: {
      "src": require("../assets/spinner.gif"),
      "width": "20rem"
    }
  }), _vm._v("\n          Cambiar contraseña\n        ")])], 1)] : _vm._e(), _vm._v(" "), (_vm.loadFailed && !_vm.success && !_vm.submitting) ? [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + ". Enlace invalido.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row pr-3 d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "cursor-pointer",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goToRecover()
      }
    }
  }, [_vm._v("\n          ← Volver a solicitar\n        ")])], 1)] : _vm._e(), _vm._v(" "), (_vm.success && !_vm.loadFailed && !_vm.submitting) ? [_c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        Tu contraseña se ha actualizado correctamente\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row pr-3 d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "cursor-pointer",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goToRecover()
      }
    }
  }, [_vm._v("\n          ← Volver a recuperar\n        ")])], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e2a2d25"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePassword.vue
// module id = 444
// module chunks = 1